import React, {createRef} from "react";
import {useFormikContext} from "formik";
import {Grid} from '@mantine/core';
import useStyles from "../../../VehiculoForm/Checkout/styles";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import PhoneInput from "react-phone-number-input";
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";

export default function TitularForm(props) {

    const {
        formField: {name, lastName, phone, email, codLocalidad, dni},
        localidadesData
    } = props;
    const {values, setFieldValue} = useFormikContext()
    const classes = useStyles();
    const ref = createRef();

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={name.name}
                        label={name.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={lastName.name}
                        label={lastName.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={phone.name}
                            label={phone.label}
                            value={values.phone}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(phone.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={codLocalidad.name}
                        label={codLocalidad.label}
                        data={localidadesData}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
